<template>
    <div class="notice">
        <headerNotice routerName="业务员公告"/>
        <div class="content">
            <!-- 搜索与新增 -->
            <div class="search-box">
                <el-row :gutter="20">
                    <el-col :span="6">
                        <el-input placeholder="请输入公告标题" v-model="searchInpt">
                            <el-button @click="getListBySearch" slot="append" icon="el-icon-search"></el-button>
                        </el-input>
                    </el-col>
                    <el-col :span="2" :offset="16">
                        <el-button type="primary" @click="showAddPan = !showAddPan">
                            <i class="el-icon-plus"></i> 新增
                        </el-button>
                    </el-col>
                </el-row>
            </div>
            <!-- 表格 -->
            <el-table
                v-loading="loading"
                ref="singleTable"
                :data="notifyList"
                highlight-current-row
                row-key="notifyID"
                :expand-row-keys="expandKeys"
                @row-click="rowClick"
                style="width: 100%; border: 1px solid rgba(228, 228, 228, 1); border-radius: 4px;"
            >
                <el-table-column align="center" type="expand">
                    <template slot-scope="props">
                        <h1 style="font-size: 16px; margin-bottom: 5px;">公告内容</h1>
                        <p>{{ props.row.content }}</p>
                    </template>
                </el-table-column>
                <el-table-column align="center" property="title" label="标题"></el-table-column>
                <!-- <el-table-column align="center" label="发布状态">
          <template slot-scope="scope">{{ scope.row.status | statusFilter}}</template>
                </el-table-column>-->
                <el-table-column align="center" property="notifyTime" label="发布时间"></el-table-column>
                <el-table-column align="center" property="createTime" label="创建时间"></el-table-column>
                <el-table-column align="center" property="createTime" label="操作">
                    <template slot-scope="scope">
                        <el-button
                            @click="deleteNotify(scope.row.notifyID)"
                            type="text"
                            size="small"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination-wrapper">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[10, 20, 30, 40]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
                center
            ></el-pagination>
        </div>
        <!-- 弹窗 -->
        <el-dialog title="收货地址" :visible.sync="showAddPan">
            <template slot="title">
                <h1>
                    基本信息
                    <span style="font-size: 12px; color: #ccc; font-weight: 400;">
                        (
                        <i style="color: red; font-style:normal;">*</i> 必填)
                    </span>
                </h1>
            </template>
            <el-form ref="form" :rules="rules" :model="form">
                <el-row :gutter="20">
                    <el-col :span="18">
                        <el-form-item prop="title" label="公告标题: " label-width="90px">
                            <el-input
                                placeholder="请输入公告标题(限50字内)"
                                v-model="form.title"
                                autocomplete="off"
                                maxlength="50"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item prop="content" label="公告内容: " label-width="90px">
                    <el-input
                        :rows="8"
                        resize="none"
                        type="textarea"
                        v-model="form.content"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div align="center" slot="footer" class="dialog-footer">
                <el-button @click="showAddPan = false">
                    <i class="el-icon-circle-close-outline"></i>
                    取 消
                </el-button>
                <el-button :loading="btnLoading" type="primary" @click="checkFrom">
                    <i class="el-icon-circle-check-outline"></i>
                    保 存
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
export default {
  components: {
    headerNotice
  },
  props: {},
  data() {
    return {
      loading: false,
      btnLoading: false,
      expandKeys: [],
      form: {},
      showAddPan: false,
      searchInpt: "",
      notifyList: [],
      pageSize: 10,
      totalCount: 0,
      currentPage: 1,
      rules: {
        title: [{ required: true, message: "请输入公告标题", trigger: "blur" }],
        content: [
          { required: true, message: "请输入公告内容", trigger: "blur" }
        ]
      }
    };
  },
  watch: {
    showAddPan(val) {
      if (!val) {
        this.$refs.form.resetFields();
      }
    }
  },
  computed: {},
  methods: {
    getData(params) {
      let self = this;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminNotify/GetNotifyList",
        params: params,
        success(res) {
          console.log(res);
          self.notifyList = res.items;
          // self.memberList = self.dealMemberList(res)
        },
        fail(res) {
          // self.loading = false;
        }
      });
    },
    // 展开、折叠行
    rowClick(row) {
      let index = this.expandKeys.findIndex(item => {
        return item === row.notifyID;
      });
      if (index === -1) {
        this.expandKeys.push(row.notifyID);
      } else {
        this.expandKeys.splice(index, 1);
      }
    },
    // 搜索
    getListBySearch() {
      this.getNotifyList({
        title: this.searchInpt,
        MaxResultCount: this.pageSize,
        SkipCount: 0
      });
      this.currentPage = 1;
    },
    //获取公告列表
    getNotifyList(params) {
      let self = this;
      self.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminNotify/GetNotifyList",
        params: params,
        success(res) {
          console.log(res);
          self.notifyList = res.items;
          self.totalCount = res.totalCount;
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    // 检查列表
    checkFrom() {
      // this.showAddPan = false
      this.$refs.form.validate(valid => {
        if (valid) {
          console.log(this.form);
          this.sendNotify();
        } else {
          console.log(this.form);
          this.$message({
            showClose: true,
            message: "请输入公告信息！",
            type: "warning"
          });
          return false;
        }
      });
    },
    // 发布公告
    sendNotify() {
      let self = this;
      let form = Object.assign({}, self.form, { typeID: 0, scope: 0 });
      self.btnLoading = true;
      $http.POST({
        url:
          this.$store.state.apiUrl + "/api/services/app/AdminNotify/SendNotify",
        data: self.form,
        success(res) {
          self.$message({
            showClose: true,
            message: "操作成功！",
            type: "success"
          });
          self.btnLoading = false;
          self.showAddPan = false;
          self.searchInpt = "";
          self.getNotifyList({ MaxResultCount: self.pageSize });
          self.currentPage = 1;
        },
        fail(res) {
          self.btnLoading = false;
        }
      });
    },
    //删除公告
    deleteNotify(notifyID) {
      let self = this;
      this.$confirm("此操作将永久删除该公告, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          self.loading = true;
          $http.POST({
            url:
              this.$store.state.apiUrl +
              "/api/services/app/AdminNotify/DelNotify",
            data: { Id: notifyID },
            success(res) {
              self.$message.success(res.data);
              self.getData();
              self.loading = false;
            },
            fail(res) {
              console.log(res);
              self.loading = false;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 分页--跳页
    handleCurrentChange(val) {
      let skipCount = (val - 1) * this.pageSize;
      let params = {
        SkipCount: skipCount,
        MaxResultCount: this.pageSize,
        title: this.searchInpt
      };
      this.getNotifyList(params);
    },
    // 分页--数据条数
    handleSizeChange(val) {
      this.pageSize = val;
      let params = {
        MaxResultCount: val,
        title: this.searchInpt
      };
      this.getNotifyList(params);
    }
  },
  filters: {
    statusFilter(status) {
      return status ? "已发布" : "未发布";
    }
  },
  created() {
    this.getNotifyList({
      // SkipCount: 0,
      MaxResultCount: this.pageSize
    });
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.notice {
  .content {
    padding: 0 50px;
    .search-box {
      padding: 40px 0 20px;
    }
    .title-tip {
      color: red;
    }
  }
  .pagination-wrapper {
    text-align: center;
    margin-top: 20px;
  }
}
</style>
